<div class="page-container">
  <!-- Page Header -->
  <intelishs-page-header title="Vacaciones" subtitle="Gestión de solicitudes de vacaciones" />

  <!-- Stats cards -->
  <div class="stats-row">
    <intelishs-stat-chip
      color="dark"
      label="Total"
      [value]="totalSolicitudes()"
      [active]="!filtroEstatus"
      (select)="filtroEstatus = ''; buscar()"
    />
    <intelishs-stat-chip
      color="orange"
      label="Pendientes"
      [value]="totalPendientes()"
      [active]="filtroEstatus === 'Pendiente'"
      (select)="filtroEstatus = 'Pendiente'; buscar()"
    />
    <intelishs-stat-chip
      color="blue"
      label="Aprobadas Dir."
      [value]="totalAprobadaDir()"
      [active]="filtroEstatus === 'Aprobada Director'"
      (select)="filtroEstatus = 'Aprobada Director'; buscar()"
    />
    <intelishs-stat-chip
      color="green"
      label="Aprobadas"
      [value]="totalAprobadas()"
      [active]="filtroEstatus === 'Aprobada'"
      (select)="filtroEstatus = 'Aprobada'; buscar()"
    />
    <intelishs-stat-chip
      color="red"
      label="Rechazadas Dir."
      [value]="totalRechazadasDir()"
      [active]="filtroEstatus === 'Rechazada Director'"
      (select)="filtroEstatus = 'Rechazada Director'; buscar()"
    />
    <intelishs-stat-chip
      color="red"
      label="Rechazadas"
      [value]="totalRechazadas()"
      [active]="filtroEstatus === 'Rechazada'"
      (select)="filtroEstatus = 'Rechazada'; buscar()"
    />
    <intelishs-stat-chip
      color="gray"
      label="Canceladas"
      [value]="totalCanceladas()"
      [active]="filtroEstatus === 'Cancelada'"
      (select)="filtroEstatus = 'Cancelada'; buscar()"
    />
  </div>

  <!-- Actions bar -->
  <div class="actions-bar">
    <div class="actions-left">
      <button nz-button class="btn-add" (click)="irAAutorizaciones()">
        <nz-icon nzType="audit" />
        Autorizaciones
        @if (totalPendientesAccion() > 0) {
          <nz-badge [nzCount]="totalPendientesAccion()" class="badge-count" />
        }
      </button>
    </div>
  </div>

  <!-- Table -->
  <intelishs-data-table
    [data]="solicitudesFiltradas()"
    [columns]="columns"
    [loading]="loading()"
    [pageSize]="15"
    [pageSizeOptions]="[10, 15, 25, 50]"
    searchPlaceholder="Buscar por nombre, ID, puesto, área o dirección..."
    [extraFilterKeys]="extraFilterKeys"
    [exportColumns]="exportColumns"
    [showRefreshButton]="true"
    (refresh)="cargar()"
    [showExportButton]="true"
    exportFilename="Vacaciones"
  >
    <!-- Empleado: nombre arriba, "ID · puesto" como contexto -->
    <ng-template intelishsCellTemplate="empleadoNombre" let-row>
      <intelishs-cell-stack
        [main]="row.empleadoNombre"
        [meta]="row.empleadoIdInterno + (row.puesto ? ' · ' + row.puesto : '')"
      />
    </ng-template>

    <!-- Área arriba, dirección como contexto (se trunca con tooltip) -->
    <ng-template intelishsCellTemplate="area" let-row>
      <intelishs-cell-stack [main]="row.area || '—'" [meta]="row.direccion || ''" />
    </ng-template>

    <!-- Periodo: el rango se lee junto y los días hábiles dan el contexto -->
    <ng-template intelishsCellTemplate="fechaInicio" let-row>
      <intelishs-cell-stack
        [main]="
          (row.fechaInicio | date: 'dd/MM/yyyy') + ' → ' + (row.fechaFin | date: 'dd/MM/yyyy')
        "
        [meta]="row.diasSolicitados + (row.diasSolicitados === 1 ? ' día hábil' : ' días hábiles')"
      />
    </ng-template>

    <ng-template intelishsCellTemplate="acciones" let-row>
      <intelishs-table-actions
        [row]="row"
        [actions]="tableActions"
        (action)="onAction({ action: $event, row })"
      />
    </ng-template>
  </intelishs-data-table>
</div>

<!-- ── Modal detalle de solicitud ─────────────────────────────────── -->
<app-solicitud-detalle-modal
  [(visible)]="detalleVisible"
  [solicitud]="detalleSolicitud()"
  modo="admin"
/>

<!-- ── Modal edición administrativa ───────────────────────────────── -->
<app-solicitud-editar-admin-modal
  [(visible)]="editVisible"
  [solicitud]="editSolicitud()"
  (saved)="onEditarGuardado()"
/>
